import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import Header from 'components/Header';
import Carousel from 'components/Carousel';
import Loading from 'components/Loading';
import styles from './index.less';
import { getShowTopBar, getValue } from '../../../utils/getValue';
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
import 'react-photo-view/dist/index.css';

const languageMap = {
  'zh-cn': {
    OfferInfo: '优惠信息',
    ViewDetails: '查看详情',
    Reminder: '温馨提示',
    HotFood: '热食',
    Servicelnfo: '服务介绍',
    MealInfo: '餐厅介绍',
    Rule: '服务须知',
    Amenities: '设施',
    BoardingGate: '登机口',
    SetMealOption: '套餐内容',
    ServingTime: '供应时间',
    ViewFullMenu: '查看完整菜单',
    Usebtn: '生成使用凭证',
  },
  en: {
    OfferInfo: 'Offer Info',
    ViewDetails: 'View Details',
    Reminder: 'Reminder',
    HotFood: 'Hot Food',
    Servicelnfo: 'Service Info',
    MealInfo: 'Restaurant introduction',
    Rule: 'T&Cs',
    Amenities: 'Amenities',
    BoardingGate: 'BoardingGate',
    SetMealOption: 'Set Meal Option',
    ServingTime: 'Serving Time',
    ViewFullMenu: 'View Full Menu',
    Usebtn: 'CONFIRM TO ACCESS LOUNGE',
  },
};

@connect(({ meal, loading }) => ({
  mealDetail: meal.mealDetail,
  loading: loading.effects['meal/queryLoungeDetail'],
}))
class MealProDetail extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { id, language } = this.props.location.query;
    this.props.dispatch({
      type: 'meal/queryMealDetail',
      payload: {
        id,
        language,
      },
    });
  }

  render() {
    const { mealDetail, loading } = this.props;
    const {
      name,
      imageList,
      locationGuideImg,
      locationGuideTips,
      terminal,
      inspection,
      businessHours,
      airportName,
      locationGuide,
      rule,
      remark,
    } = mealDetail;
    const showTopBar = getShowTopBar();
    const lg = getValue('language') || 'zh-cn';
    const className = styles[!showTopBar ? 'spdbContent' : 'mainContent'];

    return (
      <Fragment>
        <Header title={name} />

        <Loading loading={loading}>
          <div className={className}>
            <Carousel
              styleClass={{ height: '4.3rem', overflow: 'hidden' }}
              bannerItem={imageList}
              autoplay={false}
            />

            <div className={`${styles.message}`}>
              <div className={styles.messageInner}>
                <div className={styles.terminal}>
                  {terminal}, {inspection}
                </div>
                <div className={styles.lounge}>{name}</div>
                <div className={styles.line} />

                <div className={styles.useTime}>{businessHours}</div>
                {/* 位置详情 */}
                <div
                  className={styles.location}
                  dangerouslySetInnerHTML={{ __html: locationGuide }}
                />
                <div className={styles.airport}>{airportName}</div>
                {/* 平面示意图 */}
                {!!locationGuideImg && (
                  <div className={styles.guideBox}>
                    <div className={styles.guideTipBox}>
                      <span>平面示意图</span>
                      <span className={styles.guidetip}>（ 点击图片放大 ）</span>
                    </div>
                    <div className={styles.guideImgBox}>
                      <PhotoProvider>
                        <PhotoConsumer src={locationGuideImg}>
                          <img className={styles.guideImg} src={locationGuideImg} alt="" />
                        </PhotoConsumer>
                      </PhotoProvider>
                    </div>
                  </div>
                )}

                {/* 路线指引 */}
                {!!locationGuideTips && (
                  <div className={styles.guideBox}>
                    <div className={styles.guideTipBox}>
                      <span>路线指引</span>
                    </div>
                    <div
                      className={styles.locationGuide}
                      dangerouslySetInnerHTML={{ __html: locationGuideTips }}
                    />
                  </div>
                )}

                <div className={styles.line} />

                {remark && (
                  <>
                    <div className={styles.serviceNote}>
                      <div className={styles.title}>{languageMap[lg].MealInfo}</div>
                      <div
                        className={styles.serviceNoteInner}
                        dangerouslySetInnerHTML={{ __html: remark }}
                      ></div>
                    </div>

                    <div
                      style={{
                        height: '.02rem',
                        background: '#f4f4f4',
                        marginBottom: '.4rem',
                      }}
                    />
                  </>
                )}
                {rule && (
                  <div className={styles.serviceNote}>
                    <div className={styles.title}>{languageMap[lg].Rule}</div>
                    <div
                      className={styles.serviceNoteInner}
                      dangerouslySetInnerHTML={{ __html: rule }}
                    ></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Loading>
      </Fragment>
    );
  }
}

export default MealProDetail;
